import React from 'react'

const Tab = ({children, active, title, className, ...root}) => {
  return (
    <div
      className={`${
        active ? 'c-tabs__tab--active' : ''
      } c-tabs__tab ap-typography ap-typography--sm ap-ellipsis ${className || ''}`}
      {...root}
      title={title}
    >
      <span className="ap-ellipsis">{children}</span>
    </div>
  )
}

export default Tab
